//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import elementDetails from './element-details.vue'
import {toggleDoneness} from '../db-utils.js';
import {
  countDone,
  calcItemColor,
} from '../utils.js';

export default {
  props: [
    'task',
    'parentcolor'
  ],
  data() {
    return {
      hoverActive: false,
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  components: {
    elementDetails,
  },
  methods: {
    toggleDone() {
      if (this.specialState) return;
      toggleDoneness(this.task, this);
    },
    onPointerEnter(event) {
      if (event.pointerType !== 'touch') {
        this.hoverActive = true;
      }
    },
    onPointerLeave(event) {
      if (event.pointerType !== 'touch') {
        this.hoverActive = false;
      }
    },
  },
  computed: {
    isDone() {
      return !!this.task.doneAtTimestampMs
    },
    itemIcon() {
      switch (this.task.type) {
        case "task": return this.isDone ? 'check_box' : 'check_box_outline_blank'
        case "goal": return this.isDone ? 'flag' : 'outlined_flag'
        case "event": return 'event'
      }
    },
    checkboxHint() {
      return !!this.task.doneAtTimestampMs
        ? this.$gettext('Mark as not done')
        : this.$gettext('Mark as done')
    },
    editMode() {
      return this.$taskCardsController.editModeTaskId === this.task._id;
    },
    attachMode() {
      return !!this.$taskCardsController.attachCandidatesIds;
    },
    selectionMode() {
      return !!this.$taskCardsController.selectedTasksIds;
    },
    specialState() {
      return this.editMode || this.attachMode || this.selectionMode;
    },
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
    obscuredName() {
      return this.task.name.replace(/\p{L}/gu, '●').replace(/\p{N}/gu, '●');
    },
  },
};
